module.exports = __webpack_public_path__ + "img/EXTERIOR-SCROSS-1.98667609.jpg";